import { useSearchParams } from 'react-router-dom'

export const useSearch = () => {
  const [urlSearchParams] = useSearchParams()
  const q = urlSearchParams.get('q') || ''
  return { q }
}
